import type { LevelUpCount } from "./api";
import "./Mission.css"; // .lu-chip

// "Level ups 2/3" for teachers (decision 101): how many of the lesson's level-ups a student has done,
// on Submissions (list and detail) and the live view's tiles. Only for lessons that have level-ups.
// Coins, not grades (D70): this is to see who kept going, never a score.

export function LevelUpChip({ count }: { count: NonNullable<LevelUpCount> }) {
  return (
    <span className={`lu-chip${count.done === count.total ? " full" : ""}`} title="Level-ups done (extra challenges, not graded)">
      <span aria-hidden="true">★ </span>Level ups {count.done}/{count.total}
    </span>
  );
}
